import React from "react";
import ReactDOM from "react-dom";
import { X } from "lucide-react";

const Modal: React.FC<React.PropsWithChildren<{
  isOpen: boolean;
  onClose: () => void;
  title: string;
  size?: "md" | "lg" | "xl" | "2xl" | "4xl";
  position?: "center" | "top-center";
  zIndex?: number;
}>> = ({ isOpen, onClose, title, children, size = "2xl", position = "center", zIndex = 50 }) => {
  if (!isOpen) return null;

  const sizeClasses: { [key: string]: string } = {
    "md": "max-w-md",
    "lg": "max-w-lg",
    "xl": "max-w-xl",
    "2xl": "max-w-2xl",
    "4xl": "max-w-4xl",
  };

  const isTop = position === "top-center";
  const outerPositionClass = isTop ? "block overflow-y-auto" : "flex items-center justify-center";
  const innerPositionClass = isTop ? "mx-auto mt-20" : "";

  return ReactDOM.createPortal(
    <div
      className={`fixed inset-0 w-screen h-[100dvh] md:h-screen bg-black/80 ${outerPositionClass} p-4 backdrop-blur-sm`}
      style={{ zIndex }}
      onClick={onClose}
    >
      <div
        className={`bg-slate-900 border-4 border-sworn-brown rounded-xl p-4 md:p-6 shadow-2xl w-full ${sizeClasses[size]} ${innerPositionClass} max-h-[90vh] flex flex-col bg-[#2d2d2d] shadow-[inset_0_0_8px_rgba(0,0,0,0.5)]`}
        onClick={e => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-4 flex-shrink-0 border-b-2 border-sworn-brown pb-3">
          <h3 className={`text-xl md:text-2xl font-bold text-sworn-gold`}>{title}</h3>
          <button 
            onClick={onClose} 
            className="text-slate-400 hover:text-white transition-colors"
            aria-label="Close"
          >
            <X className="w-6 h-6" />
          </button>
        </div>
        <div className="overflow-y-auto pr-2 -mr-2">
          {children}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default Modal;
